<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
    >
        <path
            d="M3 13.5h2v7a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-7h2a.5.5 0 00.35-.85l-9-8.5a.5.5 0 00-.7 0l-9 8.5A.5.5 0 003 13.5z"
        />
    </svg>
</template>

<script>
export default { name: "HomeIcon" };
</script>
